export const processingFeesSelectors = {
  gridData: (state) => state.gridData,
  update: (state) => state.update,
}
